<ng-template #ModalCadastrarUsuario>
  <ng-container [ngTemplateOutlet]="conteudo"></ng-container>
</ng-template>
<ng-template #conteudo>
  <div class="modal-content">
    <div class="modal-header u-padding-vertical-0">
      <a>Novo Usuario</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>

    <form [formGroup]="formCadastraUsuario">
      <div *ngIf="passo === 1">
        <div *ngIf="token.tipoUsuario === 'INT'">
          <label>Tipo</label>
          <select formControlName="tipoUsuario">
            <option class="options__cadastro" disabled="true" [ngValue]="''">
              Selecionar
            </option>
            <option *ngFor="let tipo of tipos" [ngValue]="tipo.siglaTipo">
              {{tipo.tipo}}
            </option>
          </select>
          <app-mensagem-erro-input
            *ngIf="formCadastraUsuario.get('tipoUsuario')?.invalid && formCadastraUsuario.get('tipoUsuario')?.touched">Tipo
            usuário é
            obrigatório.</app-mensagem-erro-input>
        </div>

        <ng-container *ngIf="tipoUsuarioSendoCadastrado === 'EXT'">
          <ng-container *ngIf="token.tipoUsuario === 'INT' || token.codGrupoEconomico">
            <label>Grupo Econômico</label>
            <select formControlName="codGrupoEconomico">
              <option class="options__cadastro" disabled="true" [ngValue]="''">
                Selecionar
              </option>
              <option *ngFor="let grupo of gruposEconomicos.registros" [ngValue]="grupo.codigo">
                {{grupo.nome}}
              </option>
            </select>
            <app-mensagem-erro-input
              *ngIf="!formCadastraUsuario.get('associarContrato')?.value && !formCadastraUsuario.get('codGrupoEconomico')?.value && formCadastraUsuario.get('codGrupoEconomico')?.touched">Grupo
              econômico é obrigatório.</app-mensagem-erro-input>
            <div class="associar-contrato">
              <mat-checkbox formControlName="associarContrato"
                [disabled]="formCadastraUsuario.get('codGrupoEconomico')?.value === ''">Associar usuário a
                contratos</mat-checkbox>
            </div>
          </ng-container>

          <ng-container *ngIf="this.formCadastraUsuario.get('associarContrato')?.value || token.codContrato.length > 0">
            <label>Contrato - Nome do Cliente</label>
            <app-select-all-options formControlName="codContrato" [opcoes]="contratos.registros"
              [valorOpcao]="valorOpcaoSelectContrato"
              [exibirOpcao]="exibirOpcaoSelectContrato(environment)"></app-select-all-options>
            <app-mensagem-erro-input
              *ngIf="formCadastraUsuario.get('codContrato')?.value.length === 0 && formCadastraUsuario.get('codContrato')?.touched">Ao
              menos um contrato deve ser informado.</app-mensagem-erro-input>
          </ng-container>
        </ng-container>
      </div>

      <ng-container *ngIf="passo === quantidadePassos">
        <div>
          <label>Perfil</label>
          <select formControlName="perfil">
            <option class="options__cadastro" disabled="true" [ngValue]="null">
              Selecionar
            </option>
            <option *ngFor="let perfil of perfis.registros" [ngValue]="perfil">
              {{perfil.nome}}
            </option>
          </select>
          <app-mensagem-erro-input
            *ngIf="!formCadastraUsuario.get('perfil')?.value && formCadastraUsuario.get('perfil')?.touched">Perfil é
            obrigatório.</app-mensagem-erro-input>
          <div *ngIf="perfis.registros.length === 0" class="perfil-inexistente">
            <mat-icon matTooltip="É necessário cadastrar um novo perfil com o Grupo Econômico desejado"
              matTooltipClass="tooltip-perfil-inexistente">live_help</mat-icon>
            <span>Não existem perfis para o Grupo Econômico selecionado!</span>
          </div>
          <div *ngIf="formCadastraUsuario.get('perfil')?.value" class="informacoes-perfil-content"
            class="informacoes-perfil-content">
            <img class="icon-permissoes" (click)="listarPermissoes()" src="/assets/images/simbolos/information.svg"
              alt="Permissões do Perfil">
            <span class="perfil-label ml-5">Veja as permissões desse perfil</span>
          </div>
        </div>


        <div>
          <label>Nome</label>
          <input formControlName="nome" placeholder="Digite aqui">
        </div>
        <app-mensagem-erro-input
          *ngIf="!formCadastraUsuario.get('nome')?.value && formCadastraUsuario.get('nome')?.touched">Nome é
          obrigatório.</app-mensagem-erro-input>

        <div>
          <label>Email</label>
          <input formControlName="email" placeholder="Digite aqui">
        </div>
        <app-mensagem-erro-input
          *ngIf="!formCadastraUsuario.get('email')?.value && formCadastraUsuario.get('email')?.touched">Email é
          obrigatório.</app-mensagem-erro-input>
        <app-mensagem-erro-input
          *ngIf="formCadastraUsuario.get('email')?.value && formCadastraUsuario.get('email')?.errors?.email && formCadastraUsuario.get('email')?.touched">Email
          em formato inválido.</app-mensagem-erro-input>

        <ng-container *ngIf="formCadastraUsuario.get('tipoUsuario')?.value === 'EXT'">
          <div>
            <label>Telefone</label>
            <input formControlName="telefone" placeholder="Digite aqui" mask="(00) 0000-0000">
          </div>
          <app-mensagem-erro-input
            *ngIf="!formCadastraUsuario.get('telefone')?.value && !formCadastraUsuario.get('celular')?.value && formCadastraUsuario.get('telefone')?.touched">É
            preciso informar pelo menos um número para contato.</app-mensagem-erro-input>
          <app-mensagem-erro-input
            *ngIf="formCadastraUsuario.get('telefone')?.errors?.mask && formCadastraUsuario.get('telefone')?.touched">Telefone
            inválido.</app-mensagem-erro-input>
          <div>
            <label>Celular</label>
            <input formControlName="celular" placeholder="Digite aqui" mask="(00) 00000-0000">
          </div>
          <app-mensagem-erro-input
            *ngIf="!formCadastraUsuario.get('telefone')?.value && !formCadastraUsuario.get('celular')?.value && formCadastraUsuario.get('celular')?.touched">É
            preciso informar pelo menos um número para contato.</app-mensagem-erro-input>
          <app-mensagem-erro-input
            *ngIf="formCadastraUsuario.get('celular')?.errors?.mask && formCadastraUsuario.get('celular')?.touched">Celular
            inválido.</app-mensagem-erro-input>
        </ng-container>
      </ng-container>

      <button [disabled]="formCadastraUsuario.invalid" (click)="prosseguir()" class="button-primary">
        {{textoBotao}}
      </button>

      <app-indicador-circular-paginacao class="progresso" [quantidadeDePaginas]="quantidadePassos"
        [paginaAtiva]="passo"></app-indicador-circular-paginacao>
    </form>

  </div>
</ng-template>

<app-modal-general [showOrHideButton]="false" [showOrHideMessage]="false" [titulo]="'Permissões'"
  class="modal-listar-permissoes">
  <div class="modal-listagem-permissoes">
    <ul *ngIf="perfilSelecionado">
      <!--# Faturas (Financeiro) -->
      <!-- <li
        [ngClass]="perfilSelecionado.listarDemonstrativosFinanceiros ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Demonstrativos Financeiros</li>
      <li
        [ngClass]="perfilSelecionado.exibirDetalhesDemonstrativoFinanceiro ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Demonstrativo Financeiro</li>
      <li [ngClass]="perfilSelecionado.realizarDownloadFechamento ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Fechamento</li> -->

      <!--# Boletos (Financeiro) -->
      <!-- <li [ngClass]="perfilSelecionado.listarBoletos ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Boletos</li>
      <li [ngClass]="perfilSelecionado.realizarDownloadBoleto ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Boleto</li> -->

      <!--# Equipamentos (Serviços) -->
      <li [ngClass]="perfilSelecionado.listarEquipamentos ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Equipamentos</li>
      <li
        [ngClass]="perfilSelecionado.realizarDownloadListagemEquipamentos ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Listagem de Equipamentos</li>
      <li [ngClass]="perfilSelecionado.editarEquipamento ? 'permissao-existente' : 'permissao-inexistente'">
        Editar Equipamento</li>
      <li [ngClass]="perfilSelecionado.abrirChamadoEquipamento ? 'permissao-existente' : 'permissao-inexistente'">
        Abrir Chamado para Equipamento</li>
      <li [ngClass]="perfilSelecionado.visualizarChamadosEquipamento ? 'permissao-existente' : 'permissao-inexistente'">
        Visualizar Chamados do Equipamento</li>

      <!--# Histórico de Chamados (Serviços) -->
      <li [ngClass]="perfilSelecionado.listarChamadosAndamento ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Chamados em Andamento</li>
      <li [ngClass]="perfilSelecionado.listarChamadosFinalizados ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Chamados Finalizados</li>
      <li [ngClass]="perfilSelecionado.exibirDetalhesChamado ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Chamado</li>

      <!--# Novo Pedido (Suprimentos) -->
      <li [ngClass]="perfilSelecionado.abrirChamadoSuprimentos ? 'permissao-existente' : 'permissao-inexistente'">
        Abrir Chamado de Suprimentos</li>

      <!--# Histórico de Pedidos (Suprimentos) -->
      <li [ngClass]="perfilSelecionado.listarHistoricosPedidos ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Históricos de Pedidos</li>
      <li [ngClass]="perfilSelecionado.exibirDetalhesPedido ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Pedido</li>

      <!--# Inventário -->
      <!-- <li [ngClass]="perfilSelecionado.listarInventarios ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Inventários</li>
      <li [ngClass]="perfilSelecionado.exibirDetalhesInventario ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Inventário</li>
      <li [ngClass]="perfilSelecionado.alterarPosseInventario ? 'permissao-existente' : 'permissao-inexistente'">
        Alterar Posse de Inventário</li>
      <li
        [ngClass]="perfilSelecionado.realizarDownloadListagemInventario ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Listagem de Inventário</li> -->

      <!--# Contratos -->
      <!-- <li [ngClass]="perfilSelecionado.listarContratos ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Contratos</li>
      <li [ngClass]="perfilSelecionado.exibirDetalhesContrato ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Contrato</li>
      <li
        [ngClass]="perfilSelecionado.realizarDownloadListagemContrato ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Listagem de Contrato</li>
      <li
        [ngClass]="perfilSelecionado.realizarDownloadEquipamentosContrato ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Equipamentos do Contrato</li> -->

      <!--# Usuários -->
      <li [ngClass]="perfilSelecionado.listarUsuarios ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Usuários</li>
      <li [ngClass]="perfilSelecionado.listarPerfis ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Perfis</li>
      <li [ngClass]="perfilSelecionado.controlarUsuarios ? 'permissao-existente' : 'permissao-inexistente'">
        Controlar Usuários</li>
      <li [ngClass]="perfilSelecionado.controlarPerfis ? 'permissao-existente' : 'permissao-inexistente'">
        Controlar Perfis</li>
      <li [ngClass]="perfilSelecionado.gerenciarPermissoes ? 'permissao-existente' : 'permissao-inexistente'">
        Gerenciar Permissões</li>
    </ul>
  </div>
</app-modal-general>